module.exports = __webpack_public_path__ + "img/tecnologia-experiencia.857626ad.png";